import React from "react";
import classes from "./AccordionAfinando.module.scss";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Zoom from "@mui/material/Zoom";

const AccordionAfinando = ({
  expanded,
  onChange,
  expandIcon,
  title,
  description,
  classPrimary = "",
  transitionDelay,
}) => {
  return (
    <Zoom
      in={true}
      style={{
        transitionDelay: transitionDelay ? `${transitionDelay}ms` : "0ms",
      }}
    >
      <Accordion
        className={`${classes.Accordion} ${classPrimary}`}
        expanded={expanded}
        onChange={onChange}
        sx={{
          "&.Mui-expanded": {
            margin: 0,
            borderRadius: 4,
          },
          "&:first-of-type": {
            borderRadius: 4,
          },
          "&:last-of-type": {
            borderRadius: 4,
          },
          "&:before": {
            display: "none",
          },
          borderRadius: 4,
        }}
      >
        <AccordionSummary
          expandIcon={expandIcon}
          sx={{
            maxHeight: "50px",
            "&.Mui-expanded": {
              minHeight: "10px",
              margin: 0,
            },
          }}
        >
          <div className={classes.Title}>{title}</div>
        </AccordionSummary>
        <AccordionDetails
          className={classes.Description}
          sx={{
            padding: "2px 16px 8px",
          }}
        >
          {description}
        </AccordionDetails>
      </Accordion>
    </Zoom>
  );
};

export default AccordionAfinando;
